import { TradeHistoryTableRow } from "module/history/component/PositionLiquidationHistory"
import { TradeHistoryTableHeaderRow } from "module/history/component/TradeHistory"

import { Table, Tbody, Thead } from "@chakra-ui/react"
import { ContractFunctionSignature } from "constant/contractFunctionSignatures"
import { useMemo } from "react"
import { PositionHistoryContainer } from "sdk-react/history/PositionHistoryContainer"

interface FilledOrderListProps {
    tickerSymbol: string
}

const POSITION_HISTORY_SIGNATURE_WHITELIST: string[] = [
    ContractFunctionSignature.OPEN_POSITION,
    ContractFunctionSignature.OPEN_POSITION_FOR,
    ContractFunctionSignature.CLOSE_POSITION,
    ContractFunctionSignature.FILL_LIMIT_ORDER,
]

export function FilledOrderList({ tickerSymbol }: FilledOrderListProps) {
    const { isLoading, positionHistories } = PositionHistoryContainer.useContainer()

    const fills = useMemo(() => {
        if (isLoading) {
            return []
        }

        return positionHistories.filter(
            ({ tickerSymbol: historyTickerSymbol, fromFunctionSignature }) =>
                historyTickerSymbol === tickerSymbol &&
                fromFunctionSignature &&
                POSITION_HISTORY_SIGNATURE_WHITELIST.includes(fromFunctionSignature),
        )
    }, [isLoading, positionHistories, tickerSymbol])

    return (
        <Table variant="simple" size="sm" width="100%" sx={{ whiteSpace: "nowrap" }}>
            <Thead>
                <TradeHistoryTableHeaderRow />
            </Thead>
            <Tbody>
                {fills.map(history => {
                    return <TradeHistoryTableRow positionHistory={history} key={history.txId} />
                })}
            </Tbody>
        </Table>
    )
}
